<div class="row" style="padding-bottom: 15px;">
  <div class="col-md-12">
      <yt-fw-default-table
      [Config]="Config"
      [Items]="DonosItems"
      [TableColumns]="DonosTableColumns">
    </yt-fw-default-table>      
  </div>
</div>
<div class="row" style="padding-bottom: 20px;">
  <div class="col-md-12">
      <yt-fw-default-table
      [Config]="ConfigTekuce"
      [Items]="items"
      [TableColumns]="TableColumns"
      [TableColumnsSums]="TableColumnsSums">
    </yt-fw-default-table>      
  </div>
</div>
<div class="row">
  <div class="col-md-12">
      <yt-fw-default-table
      [Config]="Config"
      [Items]="Ukupno"
      [TableColumns]="TableColumnsUkupno">
    </yt-fw-default-table>      
  </div>
</div>

